import BaseComponent from 'scripts/BaseComponent.js';

export default class ProductOptionSelect extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      optionToggleBtn: '.js-optionToggleBtn',
      optionBtn: '.js-optionBtn',
      selectedValue: '.js-selectedValue',
      variantIdSelect: '.js-variantId',
    };

    this.dom = {
      $component: component,
      $optionToggleBtn: this.$get(this.refs.optionToggleBtn),
      $optionBtns: this.$getAll(this.refs.optionBtn),
      $selectedValue: this.$get(this.refs.selectedValue),
      $variantIdSelect: document.querySelector(this.refs.variantIdSelect),
    };

    this.state = {
      optionsOpen: false,
      optionsOpenClass: 'open-options',
      activeOptionClass: 'active-option',
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.setClick(dom.$optionToggleBtn, this.toggleOptions);
    this.setClickWithElement(dom.$optionBtns, this.optionSelect);
  }

  toggleOptions() {
    const { state } = this;

    if (state.optionsOpen) {
      this.closeOptions();
    } else {
      this.openOptions();
    }
  }

  openOptions() {
    const { dom, state } = this;

    dom.$component.classList.add(state.optionsOpenClass);
    document.addEventListener('click', this.clickOutHandler.bind(this));
    state.optionsOpen = true;
  }

  closeOptions() {
    const { dom, state } = this;

    dom.$component.classList.remove(state.optionsOpenClass);
    document.removeEventListener('click', this.clickOutHandler.bind(this));
    state.optionsOpen = false;
  }

  clickOutHandler(e) {
    const { dom } = this;

    if (!dom.$component.contains(e.target)) {
      this.closeOptions();
    }
  }

  optionSelect(btn) {
    const { dom, state } = this;
    const { id, value } = btn.dataset;

    dom.$optionBtns.forEach((elem) => elem.classList.remove(state.activeOptionClass));
    btn.classList.add(state.activeOptionClass);

    dom.$selectedValue.textContent = value;
    dom.$variantIdSelect.value = id;
    this.closeOptions();
  }
}
